import React from 'react';

import styles from './Styles.module.scss';
import { ChromePicker } from 'react-color';

class ColorPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        showPicker: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleOutsideClicked = this.handleOutsideClicked.bind(this);
  }

  componentDidMount(){
    window.addEventListener('mousedown', this.handleOutsideClicked);
  }
  
  handleChange(color, event){
    this.props.onColorChange(color.hex);
  }


  handleOutsideClicked(e){
    if (this.colorPicker && !this.colorPicker.contains(e.target)) {
      this.setState({
        showPicker: false
      })
    }
  }

  componentWillUnmount(){
    window.removeEventListener('mousedown', this.handleOutsideClicked);
  }

  render() {
    return (
      <div ref={(element) => {
        this.colorPicker = element
      }}>
        <div className={styles.subHeading}>{this.props.title}</div>
        <div className={styles.colorPicker} 
            onClick={() => this.setState({
                showPicker: !this.state.showPicker
            })}
        >
            <div style={{background: this.props.hexColor}} className={styles.hexColor}></div>
            <span className={styles.colorCode}>{this.props.hexColor}</span>
        </div>
        {this.state.showPicker &&
          <ChromePicker color={this.props.hexColor} onChangeComplete={this.handleChange} disableAlpha={true}/>
        }
      </div>
    );
  }
}

export default ColorPicker;
